// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","button__icon":"Button_button__icon__2R4TK"};